import { dispatchGlobalEvent } from "@storytell/events";
import { StButton } from "@storytell/ui/buttons";
import { TbPaperclip, TbX } from "solid-icons/tb";

export const ScopeManagerPaneNoData = (props: { onClose?: () => void }) => {
  return (
    <div class="flex flex-col items-center">
      <div class="flex items-center justify-between w-full mb-2 gap-2">
        <h3 class="text-primary-text font-medium text-sm">Upload files to get better results</h3>
        <StButton
          icon={TbX}
          aria-label="Close"
          class="ml-2 shrink-0"
          noColor
          noBorder
          onClick={() => props.onClose?.()}
        />
      </div>

      <p class="max-w-md mb-4 text-secondary-text">
        Storytell will search through your uploads and pick out the most relevant data when providing an answer.
      </p>
      <StButton
        onClick={() => {
          dispatchGlobalEvent("open-file-picker", undefined);
          props.onClose?.();
        }}
        icon={TbPaperclip}
        class="w-full bg-brand hover:bg-brand-hover text-on-brand text-lg mb-6"
      >
        Upload
      </StButton>

      <p class="text-secondary-text text-xs max-w-md">
        You can control which files are included in the search by adding or removing them from the scope.{" "}
        <a href="https://go.storytell.ai/learn-scope" target="_blank" rel="noreferrer" class="text-brand underline">
          Learn more
        </a>
      </p>
    </div>
  );
};
